module.exports = __webpack_public_path__ + "static/media/monica-hall.70f080a4.jpg";